(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("isomorphic-fetch"));
	else if(typeof define === 'function' && define.amd)
		define("spine-web-client", ["isomorphic-fetch"], factory);
	else if(typeof exports === 'object')
		exports["spine-web-client"] = factory(require("isomorphic-fetch"));
	else
		root["spine-web-client"] = factory(root["isomorphic-fetch"]);
})(typeof window !== 'undefined' ? window : this, function(__WEBPACK_EXTERNAL_MODULE__47__) {
return 